import styled from '@emotion/styled';
import { Button, transparentize } from '@prometheus/components';
import { NavLink } from 'react-router-dom';

export const NavigationContainer = styled.div`
  padding: 0 18px;
  width: 76px;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: ${({ theme }: any) => theme.shadows[2]};
  background-color: #ffffff;
  z-index: 5;
  position: fixed;
  top: 0;
  left: 0;
  /* background: ${(props: any) => {
    return props.theme.palette?.backgroundColor.default || '#ffffff';
  }}; */
`;

export const StyledButton: any = styled(NavLink)`
  :hover {
    background-color: transparent;
  }
  .icon-wrapper {
    box-sizing: border-box;
    width: 42px;
    height: 42px;
  }
  .icon-wrapper:hover {
    background-color: ${({ theme }: any) =>
      transparentize(0.85, theme.palette.info.main)};
  }
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  align-items: center;
  padding: 8px 0px;
  min-width: auto;
  border-radius: 2px;
  width: 100%;
  text-align: center;
  svg {
    width: 26px;
    height: 26px;
    font-size: 26px;
  }
`;

export const LogoContainer = styled(NavLink)`
  padding: 12px 0px 16px;
`;
